import { Injectable, Output, EventEmitter } from '@angular/core'

@Injectable({providedIn:'root'})
export class NavigationService {

  isOpen = false;

  @Output() changeToggleMenu: EventEmitter<boolean> = new EventEmitter();

  toggleMenu() {
    this.isOpen = !this.isOpen;
    this.changeToggleMenu.emit(this.isOpen);
  }

}